var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirImp5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.951 11.084l-2.405-2.926a.318.318 0 00-.246-.116h-6.317a.318.318 0 00-.246.116L8.33 11.084a.287.287 0 00-.068.186v8.224a.31.31 0 00.315.302h11.124a.31.31 0 00.315-.302V11.27a.272.272 0 00-.066-.186zm-.855-.066h-4.64V8.646h2.691l1.95 2.372zm-7.96-2.372h2.69v2.372h-4.64l1.95-2.372zM8.892 19.192v-7.57h10.495v7.57H8.893z",
    fill: "#2B2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.14,
    cy: 13.301,
    r: 12.801,
    stroke: "#2B2B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.17,
    cy: 4.949,
    r: 4.949,
    fill: "#EEF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.529 6.806h-2.26V2.83h2.26v.596H2.98v1.013h1.447v.596H2.981v1.17h1.548v.6zm1.428-1.543l-.996-1.475h.796l.657 1.024.657-1.024h.796L6.86 5.263l1.058 1.543h-.796l-.707-1.097-.707 1.097H4.91l1.046-1.543zm5.402 12.059h-.546V14.23h1.754v.463h-1.208v.91h1.126v.463h-1.126v1.256zm3.101-2.668c-.283 0-.503.101-.659.303-.153.202-.23.477-.23.823 0 .35.073.624.217.823.145.196.367.294.667.294.13 0 .257-.013.381-.038.124-.03.254-.067.39-.113v.472c-.127.052-.255.09-.385.113a2.494 2.494 0 01-.442.034c-.318 0-.58-.065-.788-.195a1.199 1.199 0 01-.464-.554 2.15 2.15 0 01-.151-.84c0-.312.056-.586.169-.823a1.3 1.3 0 01.493-.563c.22-.136.487-.204.802-.204.155 0 .308.02.459.057.153.034.295.083.428.147l-.19.455a3.236 3.236 0 00-.342-.13 1.068 1.068 0 00-.355-.06zm1.432 2.668V14.23h.554v2.624h1.29v.468h-1.844z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirImp5);
export default __webpack_public_path__ + "static/media/air_imp_5.9fb72f4f7fa6faa71b2779655050cbda.svg";
export { ForwardRef as ReactComponent };